import { CustomIcon } from '@app/shared/models/custom-icon';

export const iconConfig: CustomIcon[] = [
  {name: 'WissenAZ', url: 'WissenAZ.svg'},
  {name: 'Tipps', url: 'Tipps.svg'},
  {name: 'Home', url: 'Home.svg'},
  {name: 'Merkliste', url: 'Merkliste.svg'},

 {name: 'Icons_BURGER', url: 'Icons_BURGER.svg'},
 {name: 'Icons_FORUM', url: 'Icons_FORUM.svg'},
 {name: 'Icons_HOME', url: 'Icons_HOME.svg'},
 {name: 'Icons_PFEIL', url: 'Icons_PFEIL.svg'},
 {name: 'Icons_VORLAGEN', url: 'Icons_VORLAGEN.svg'},
 {name: 'Icons_EDIT', url: 'Icons_EDIT.svg'},
 {name: 'Icons_DELETE', url: 'Icons_DELETE.svg'},
 {name: 'Icons_SORT', url: 'Icons_SORT.svg'},
 {name: 'Icons_BOOKMARK_ADD', url: 'Icons_BOOKMARK_ADD.svg'},
 {name: 'Icons_BOOKMARK_REMOVE', url: 'Icons_BOOKMARK_REMOVE.svg'},
 {name: 'Icons_CLOSE', url: 'Icons_CLOSE.svg'},
 {name: 'Icons_SWIPE', url: 'Icons_SWIPE.svg'},
];
